import axios from "axios";
import { getEnvVariable } from "../utils/config";
import L from "leaflet";

export const getLatLongFromAddress = async (address, npa = "", city = "") => {
  const fullAddress = `${address} ${npa} ${city} Switzerland`;
  try {
    const coordinateResponse = await axios.get(
      `https://geocode.maps.co/search?q=${fullAddress}&api_key=${getEnvVariable(
        "REACT_APP_MAPS_API_KEY"
      )}`
    );
    if (!coordinateResponse.data || !coordinateResponse.data.length) {
      throw new Error("ADDRESS_NOT_FOUND");
    }
    const latitude = coordinateResponse.data[0].lat;
    const longitude = coordinateResponse.data[0].lon;
    return { latitude, longitude };
  } catch (error) {
    // Re-throw the error so it can be handled by the caller
    if (error.message === "ADDRESS_NOT_FOUND") {
      throw error;
    }
    // For other errors, wrap them
    console.error("Error getting coordinates:", error);
    throw new Error("ADDRESS_NOT_FOUND");
  }
};

export const createRestaurantIcon = () => {
  return new L.Icon({
    iconUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });
};

export const createCompanyIcon = () => {
  return new L.Icon({
    iconUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });
};
